import { render, staticRenderFns } from "./QualificationList.vue?vue&type=template&id=d975928e&scoped=true"
import script from "./QualificationList.vue?vue&type=script&lang=ts"
export * from "./QualificationList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d975928e",
  null
  
)

export default component.exports